// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__uQPMM","main":"Layout_main__0StYP"};